import { defineMessages } from '@formatjs/intl';

export const mobileHandoffMessages = defineMessages({
	heading: {
		id: 'onboarding.recommendContent.heading',
		defaultMessage: 'Welcome to Calm{space}Premium!',
		description: 'Heading for recommended sleep',
	},
	shareSubheading: {
		id: 'onboarding.mobileHandoff.shareSubheading',
		defaultMessage:
			"We're unlocking the best of Calm for you — free for {num} days. Get started by downloading the Calm mobile app.",
		description: 'Subheading that tells the user how long their free trial is',
	},
	secondaryCta: {
		id: 'onboarding.mobileHandoff.maybeLater',
		defaultMessage: 'Maybe later',
		description: 'Secondary cta',
	},
	qrCodeInstructions: {
		id: 'onboarding.qrCodeInstructions',
		defaultMessage: 'Scan the QR code to explore in {br} the Calm App',
		description: 'Directions on how to interact with QR code',
	},
});

export const sleepQualityMessages = defineMessages({
	postOnboardRecommendationDescription: {
		id: 'onboarding.sleep.contentRecommendation',
		defaultMessage:
			'Get started with our Sleep Better collection of Sleep Stories, sleep meditations, music, soundscapes, and more',
		description: 'Post sleep onboarding collection recommendation',
	},
	postOnboardRecommendationTitle: {
		id: 'onboarding.sleep.postOnboardRecommendationTitle',
		defaultMessage: 'Sleep Better',
		description: 'Post sleep onboarding collection recommendation title',
	},
	postOnboardRecommendationSubTitle: {
		id: 'onboarding.sleep.postOnboardRecommendationSubTitle',
		defaultMessage: 'Unwind and transition to a deep sleep',
		description: 'Post sleep onboarding collection recommendation subtitle',
	},
});

export const stressMessages = defineMessages({
	postOnboardRecommendationDescription: {
		id: 'onboarding.stress.contentRecommendation',
		defaultMessage:
			'Get started with our Reduce Stress & Anxiety collection of meditations, music, breathing exercises, and more',
		description: 'Post stress onboarding collection recommendation',
	},
	postOnboardRecommendationTitle: {
		id: 'onboarding.stress.postOnboardRecommendationTitle',
		defaultMessage: 'Reduce Stress & Anxiety',
		description: 'Post stress onboarding collection recommendation title',
	},
	postOnboardRecommendationSubTitle: {
		id: 'onboarding.stress.postOnboardRecommendationSubTitle',
		defaultMessage: 'Relieve feelings of anxiety and tension',
		description: 'Post stress onboarding collection recommendation subtitle',
	},
});

export const nonTrialFlowMessages = defineMessages({
	postOnboardRecommendationDescription: {
		id: 'onboarding.nonTrialFlow.contentRecommendation',
		defaultMessage: 'Get access to your personalized content by downloading the Calm Mobile app',
		description: 'Non-trial post onboarding collection recommendation',
	},
});
